import { useState } from 'react';
import { Button, Checkbox, Header, Modal, Table } from 'semantic-ui-react';
import { DescriptorCleanedLabel, ImportDescriptorIdType, ImportTableDescriptorType } from '../../../../types';
import './styles.css';
import { getCleanedLabels } from './utils';

type LabelNormalizationModalPropsType = {
    heading: string;
    open: boolean;
    descriptors: ImportTableDescriptorType[];
    closeModal: () => void;
    onConfirm: (cleanCandidates: DescriptorCleanedLabel[]) => void;
    cancelButtonText?: string;
};

function LabelNormalizationModal({
    heading,
    closeModal,
    onConfirm,
    descriptors,
    open,
    cancelButtonText = 'CANCEL',
}: LabelNormalizationModalPropsType) {
    const [descriptorsWithDiffs, setDescriptorsWithDiffs] = useState<DescriptorCleanedLabel[]>(() =>
        getCleanedLabels(descriptors)
    );

    const handleToggleInclude = (descriptorId: ImportDescriptorIdType) => {
        setDescriptorsWithDiffs((prev) => {
            return prev.map((d) => {
                if (d.descriptorId === descriptorId) {
                    return { ...d, include: !d.include };
                }
                return d;
            });
        });
    };

    return (
        <Modal size="small" open={open} onClose={closeModal}>
            <Modal.Header>{heading}</Modal.Header>
            <Modal.Content>
                {!!descriptorsWithDiffs.length ? (
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Differences</Table.HeaderCell>
                                <Table.HeaderCell>New Value</Table.HeaderCell>
                                <Table.HeaderCell>Accept</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {descriptorsWithDiffs.map((d) => {
                                const highlightedLabel = d.highlightedLabel;
                                const cleanedLabel = d.cleanLabel;
                                return (
                                    <Table.Row key={d.descriptorId}>
                                        <Table.Cell>
                                            {highlightedLabel.length ? (
                                                <>{highlightedLabel.map((labelPart) => labelPart)}</>
                                            ) : (
                                                cleanedLabel
                                            )}
                                        </Table.Cell>
                                        <Table.Cell>{cleanedLabel}</Table.Cell>
                                        <Table.Cell textAlign="center">
                                            <Checkbox
                                                checked={d.include}
                                                onChange={() => handleToggleInclude(d.descriptorId)}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                ) : (
                    <Header>There are no labels for normalization</Header>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={() => onConfirm(descriptorsWithDiffs.filter((d) => d.include))}>
                    APPLY
                </Button>
                <Button secondary onClick={closeModal}>
                    {cancelButtonText}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default LabelNormalizationModal;
